import React, { Fragment } from "react";
import SettingAsideLeft from "../partials/SettingAsideLeft";

const FormFields = () => {
  return (
    <Fragment>
      <SettingAsideLeft />
    </Fragment>
  );
};

export default FormFields;
